import React, { useState, useContext, useRef } from 'react';
import { useIntl } from 'react-intl';

import { ThemeContext } from 'styled-components';

import CardVector from '../../../components/CardVector';
import CheckForm from './components/CheckForm';
import { fetchBalance, createCbcSession } from '../../../services';
import Transactions from './components/Transactions';
import {
  CardContainer,
  Container,
  Description,
  Seperator,
  Subtitle,
  Title,
  Wrapper,
} from './components/CheckForm/styles';

const messageFor = (intl, key, fallback) => intl.messages[key] || fallback;

export default () => {
  const intl = useIntl();
  const page = 'balance';
  const theme = useContext(ThemeContext);
  const [prn, setprn] = useState('');
  const [isprn, setisprn] = useState(false);
  const [error, setError] = useState(null);
  const recaptchaRef = useRef(null);
  const [token, setToken] = useState(null);
  const [loading, setloading] = useState(false);
  const [balanceInfo, setbalanceInfo] = useState(null);
  const isGalileo = theme.brand.processor === 'galileo';
  const isValid = () => prn && token;

  const handleChange = newToken => {
    setToken(newToken);
    setError(null);
  };

  const handleExpire = () => {
    setToken(null);
  };

  const resetCaptcha = () => {
    if (recaptchaRef.current) {
      recaptchaRef.current.reset();
    }
    setToken(null);
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setloading(true);

    try {
      const sessionRes = await createCbcSession(prn, token);

      if (sessionRes.status === 403) {
        throw new Error(messageFor(intl, 'balance-captcha-rejected', 'Captcha verification failed'));
      }
      if (sessionRes.status === 503) {
        throw new Error(messageFor(intl, 'balance-service-unavailable', 'Service temporarily unavailable'));
      }
      if (!sessionRes.ok) {
        const body = await sessionRes.json().catch(() => null);
        const msg = body && body.error && body.error.message;
        throw new Error(msg || messageFor(intl, 'balance-genericerror', 'Unable to verify'));
      }

      const res = await fetchBalance(prn);
      const json = await res.json();
      if (json.error) throw new Error(json.error.message);

      setbalanceInfo(json.data);
      setisprn(true);
      setToken(null);
      setError(null);
      resetCaptcha();
    } catch (err) {
      setError(err.message || true);
      resetCaptcha();
    }

    setloading(false);
  };

  return (
    <div page={page}>
      {!isprn && (
        <Wrapper
          className={`${
            Object.values(theme.brand.cbc_footer || {}).filter(l => l.url)
              .length > 0
              ? 'hasfooterlinks'
              : ''
          }`}
        >
          <div>
            <Title>{intl.messages[`${page}-title`]}</Title>
            <Subtitle>
              {
                intl.messages[
                  `${page}-${isGalileo ? 'subtitlegalileo' : 'subtitle'}`
                ]
              }
            </Subtitle>
          </div>
          <Container>
            <CardContainer>
              <div>
                <CardVector color={theme.brand.primary} isGalileo={isGalileo} />
              </div>
              <Seperator />
              <CheckForm
                page={page}
                setisprn={setisprn}
                handleChange={handleChange}
                handleExpire={handleExpire}
                handleSubmit={handleSubmit}
                isValid={isValid}
                loading={loading}
                error={error}
                recaptchaRef={recaptchaRef}
                prn={prn}
                setprn={setprn}
                isGalileo={isGalileo}
                setError={setError}
              />
            </CardContainer>
          </Container>
          <Description>
            {intl.messages[`${page}-privacydescription`]}
          </Description>
        </Wrapper>
      )}
      {isprn && (
        <Transactions
          page={page}
          prn={prn}
          setprn={setprn}
          setisprn={setisprn}
          locale={theme.locale}
          balanceInfo={balanceInfo}
        />
      )}
    </div>
  );
};
